export default function HowTrainingGoes() {
  const steps = [
    { icon: 'ri-search-eye-line', title: 'Диагностика', desc: 'Анализ текущего уровня Soft Skills сотрудников через интервью, опросы и наблюдение за работой команды.' },
    { icon: 'ri-crosshair-2-line', title: 'Определение целей', desc: 'Связываем развитие Soft Skills с бизнес-целями компании: улучшение сервиса, снижение текучести, рост продаж.' },
    { icon: 'ri-file-edit-line', title: 'Подготовка программы', desc: 'Адаптация методологии под специфику компании — отрасль, должности, текущие вызовы и задачи.' },
    { icon: 'ri-presentation-line', title: 'Практический тренинг', desc: 'Интенсивное обучение: 80% практики, отработка навыков на реальных ситуациях из работы компании.' },
    { icon: 'ri-task-line', title: 'Домашние задания', desc: 'Внедрение изученных инструментов в работу между модулями для закрепления новых навыков.' },
    { icon: 'ri-tools-fill', title: 'Внедрение', desc: 'Превращение теории в привычки — отработка коммуникаций, обратной связи и взаимодействия на практике.' },
    { icon: 'ri-heart-pulse-line', title: 'Сопровождение', desc: 'Посттренинговые сессии, разбор сложных ситуаций, корректировка подходов в реальном времени.' },
    { icon: 'ri-bar-chart-grouped-line', title: 'Оценка результатов', desc: 'Замер изменений: вовлечённость, текучесть, удовлетворённость клиентов, эффективность команд.' },
  ];

  return (
    <section className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Как проходит корпоративное обучение Soft Skills
        </h2>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto">
          Системный подход, который не просто даёт знания, а формирует новые поведенческие привычки всей команды
        </p>

        <div className="hidden lg:block relative">
          <div className="absolute top-14 left-0 right-0 h-1 bg-teal-200 rounded-full"></div>
          <div className="grid grid-cols-8 gap-2">
            {steps.map((step, i) => (
              <div key={i} className="relative text-center">
                <div className="w-11 h-11 bg-teal-600 rounded-full flex items-center justify-center mx-auto mb-3 relative z-10 ring-4 ring-gray-50">
                  <i className={`${step.icon} text-base text-white`}></i>
                </div>
                <div className="mt-4 pt-3">
                  <h4 className="font-bold text-gray-900 text-[11px] mb-1 leading-tight">{step.title}</h4>
                  <p className="text-gray-500 text-[10px] leading-relaxed">{step.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="lg:hidden space-y-0">
          {steps.map((step, i) => (
            <div key={i} className="flex gap-4">
              <div className="flex flex-col items-center">
                <div className="w-11 h-11 bg-teal-600 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className={`${step.icon} text-base text-white`}></i>
                </div>
                {i < steps.length - 1 && <div className="w-0.5 h-8 bg-teal-200"></div>}
              </div>
              <div className="pb-6">
                <h4 className="font-bold text-gray-900 text-sm mb-1">{step.title}</h4>
                <p className="text-gray-600 text-xs leading-relaxed">{step.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-14 text-center">
          <div className="inline-block bg-teal-50 border border-teal-200 rounded-xl px-8 py-5">
            <p className="text-lg md:text-xl font-bold text-teal-800">
              Каждый этап программы гибко адаптируется под задачи вашей компании и уровень сотрудников
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}